import type { TestExecutionListItem, TestRunDisplayStatus, TestRunTableRow } from '../../../types/testExecution.ts';

/**
 * Display status from `overall_status` only — same rules as ViewControl test-runs tab
 * (after aligning both to ignore `test_status`).
 */
export const mapApiToDisplayStatus = (
  exec: Pick<TestExecutionListItem, 'overall_status'>
): TestRunDisplayStatus => {
  if (exec.overall_status == null) return 'Interrupted';
  const os = String(exec.overall_status).toLowerCase();
  if (os === 'failed') return 'Failed';
  if (os === 'passed' || os === 'completed') return 'Passed';
  if (os === 'warning') return 'Warning';
  if (os === 'in_progress' || os === 'pending') return 'Interrupted';
  return 'Warning';
};

export const formatControlTypeLabel = (controlType: string | null | undefined): string => {
  if (!controlType) return 'Manual';
  const t = String(controlType).toLowerCase();
  if (t === 'automated') return 'Automated';
  if (t === 'manual') return 'Manual';
  return controlType.charAt(0).toUpperCase() + controlType.slice(1);
};

export const mapExecutionToTableRow = (item: TestExecutionListItem): TestRunTableRow => {
  const started = item.started_at ?? item.created_at ?? null;
  return {
    executionId: String(item.id),
    soxControlId: item.sox_control_id,
    controlName: (item.sox_control?.name && String(item.sox_control.name).trim()) || '',
    controlId: item.control_id,
    runIdLabel: `RUN-${item.test_run_number}`,
    dateLabel: started ? new Date(started).toLocaleString() : 'N/A',
    controlTypeLabel: formatControlTypeLabel(item.sox_control?.control_type),
    status: mapApiToDisplayStatus(item),
    passed: item.steps_passed ?? 0,
    failed: item.steps_failed ?? 0,
    warnings: item.steps_warning ?? 0,
    executedBy: item.executed_by ?? null,
  };
};
